import {Resource, ResponseSerialize} from 'simpli-web-sdk'
import {PanelUser} from '@/model/resource/PanelUser'

export class AuditReason extends Resource {
  idReasonPk: number = 0
  description: string | null = null
  active: boolean | null = null

  @ResponseSerialize(PanelUser)
  panelUser: PanelUser | null = null

  get $id() {
    return this.idReasonPk
  }
  set $id(val) {
    this.idReasonPk = val
  }

  get $tag() {
    return String(this.description)
  }

  get idPanelUserFk() {
    if (!this.panelUser) return 0
    return this.panelUser.$id
  }

  set idPanelUserFk(val) {
    if (!this.panelUser) this.panelUser = new PanelUser()
    this.panelUser.$id = val
  }
}
